const module = { name: 'movie/shared/desktop/Fandango.errors.movie', exports: {} }; const exports = module.exports;



const Selectors = {
    MSG_ERROR: '.js-date-picker__error',
    MSG_LOCATION: '.js-date-picker-msg',
    SPINNER: '.js-spinner',
    FAN_ALERT: '.js-fan-alert'
}


const Messages = {
    NO_SHOWTIMES: 'Currently, there are no showtimes in ',
    INVALID_ENTRY: 'This location could not be found, please try again.'
}
function toggleElement(selector, display) {
    const el = document.querySelector(selector);
    if (!el) {
        return;
    }
    if (display === 'hide') {
        el.classList.add('hide');
    }
    else if (display === 'show') {
        el.classList.remove('hide');
    }
}
function displayMessage(selector, message) {
    const el = document.querySelector(selector);
    el.innerHTML = message;
}
function noShowtimes(location) {
    toggleElement(Selectors.SPINNER, 'hide');
    toggleElement(Selectors.MSG_LOCATION, 'hide');
    toggleElement(Selectors.FAN_ALERT, 'show');
    toggleElement(Selectors.MSG_ERROR, 'show');
    displayMessage(Selectors.MSG_ERROR, Messages.NO_SHOWTIMES + (location.postalCode || location.name));
}
function inputError() {
    toggleElement(Selectors.MSG_LOCATION, 'hide');
    toggleElement(Selectors.MSG_ERROR, 'show');
    displayMessage(Selectors.MSG_ERROR, Messages.INVALID_ENTRY);
}
module.exports = {
    movie: {
        datePicker: {
            noShowtimes,
            inputError
        }
    }
};
export default module.exports;